// Topo da lista (AC-192): no lugar de "Hoje", uma saudação com o nome da pessoa por 5 min;
// depois, dicas curtas que trocam a cada 20 s, embaralhadas e sem repetir até passar
// por todas (ASM-097 / ASM-098).

export const GREETING_MS = 5 * 60_000;
export const TIP_MS = 20_000;
export const TIP_COUNT = 55;

/** A saudação varia entre a do horário, "Olá" e "Oii" (ASM-097). */
export type GreetingStyle = 'time' | 'hello' | 'hi';
export type GreetingKey = 'morning' | 'afternoon' | 'evening' | 'hello' | 'hi';

export const GREETING_STYLES: readonly GreetingStyle[] = ['time', 'hello', 'hi'];

/** Bom dia das 5h às 12h, boa tarde das 12h às 18h, boa noite no resto. */
export function greetingKey(style: GreetingStyle, hour: number): GreetingKey {
  if (style !== 'time') return style;
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'evening';
}

/** Só o primeiro nome, com a inicial maiúscula ("ana souza" → "Ana"). */
export function firstName(name: string | null | undefined): string {
  const first = (name ?? '').trim().split(/\s+/)[0] ?? '';
  return first.charAt(0).toLocaleUpperCase() + first.slice(1);
}

/** Embaralha 0..n-1 (Fisher–Yates). */
export function shuffled(n: number, random: () => number = Math.random): number[] {
  const order = Array.from({ length: n }, (_, i) => i);
  for (let i = n - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }
  return order;
}

export type HeaderTitle = { kind: 'greeting' } | { kind: 'tip'; tip: number; slot: number };

/** O que mostrar depois de `elapsedMs` desde que o app abriu. */
export function titleAt(elapsedMs: number, order: readonly number[]): HeaderTitle {
  if (elapsedMs < GREETING_MS || order.length === 0) return { kind: 'greeting' };
  const slot = Math.floor((elapsedMs - GREETING_MS) / TIP_MS);
  return { kind: 'tip', tip: order[slot % order.length], slot };
}

export interface TitleSession {
  start: number;
  style: GreetingStyle;
  order: number[];
}

export function newTitleSession(start: number, random: () => number = Math.random): TitleSession {
  return {
    start,
    style: GREETING_STYLES[Math.floor(random() * GREETING_STYLES.length)],
    order: shuffled(TIP_COUNT, random),
  };
}
